import React from "react";
import PropTypes from "prop-types";
import { parseHtml } from "../utils";

const AboutProgramme = props => {

  const { html } = props;

  const textClass = "leading-relaxed text-gray-500 mb-2 mt-2 sm:text-lg lg:mb-3";
  const parsedHtml = parseHtml(html, { p: textClass });

  return (
    <div className="py-12 sm:py-16">
      <div className="page-width">
        <div className="font-league font-semibold text-2xl mb-2 sm:text-3xl sm:mb-4">About the programme</div>
        <div dangerouslySetInnerHTML={{__html: parsedHtml}} />
      </div>
    </div>
  );
};

AboutProgramme.propTypes = {
  html: PropTypes.string.isRequired
};

export default AboutProgramme;